import React from "react";
import {
  Drawer,
  List,
  Divider,
  useTheme,
  useMediaQuery,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import { useLocation, useNavigate } from "react-router-dom";
import { menuConfig } from "./sidebarConfig";
import { useSelector } from "react-redux";
import packageJson from "../../../package.json";

const drawerWidth = 220;

const StyledListItemButton = styled(ListItemButton)(({ theme, selected }) => ({
  color: selected ? "#A5E0FF" : "#9DA2A7",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(1),
  "&:hover": {
    color: "#A5E0FF",
  },
  "& .MuiListItemIcon-root": {
    color: selected ? "#A5E0FF" : "#9DA2A7",
    marginRight: theme.spacing(1),
  },
}));

const Sidebar = ({ mobileOpen, handleDrawerToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const navigate = useNavigate();

  const userAccessLevel = useSelector((state) => state.auth.access_level);

  const filteredMenuItems = menuConfig.filter((item) =>
    item.access.includes(userAccessLevel)
  );

  const drawer = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-between",
      }}
    >
      <div>
        <Divider />
        <List style={{ marginTop: "60px" }}>
          {filteredMenuItems.map((menuItem) => (
            <StyledListItemButton
              key={menuItem.label}
              selected={location.pathname === menuItem.path}
              onClick={() => navigate(menuItem.path)}
            >
              <ListItemIcon>{menuItem.icon}</ListItemIcon>
              <ListItemText primary={menuItem.label} />
            </StyledListItemButton>
          ))}
        </List>
      </div>
      <Typography
        variant="body2"
        align="center"
        sx={{ color: "#9DA2A7", mb: 3, fontSize: "0.75rem" }}
      >
        Powered by Nexus-MD @v{packageJson.version}
      </Typography>
    </div>
  );

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#2B3342",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#3e526a",
            borderRadius: "8px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#141b25",
          },
        },
      }}
    >
      {drawer}
    </Drawer>
  );
};

export default Sidebar;
